export type RevenueAccountProfile = {
  account_id: string;
  display_name?: string;
  business_name?: string;
  account_name?: string;
  website_domain?: string;
  website_url?: string;
};

export function getAccountDisplayName(account: RevenueAccountProfile): string {
  return account.display_name?.trim()
    || account.business_name?.trim()
    || account.account_name?.trim()
    || account.website_domain?.trim()
    || account.account_id;
}

export function getAccountDomain(account: RevenueAccountProfile): string | undefined {
  if (account.website_domain?.trim()) return account.website_domain.trim();
  if (!account.website_url?.trim()) return undefined;
  try {
    return new URL(account.website_url).hostname.replace(/^www\./i, "");
  } catch {
    return undefined;
  }
}

export function sortAccountProfiles(accounts: RevenueAccountProfile[]): RevenueAccountProfile[] {
  return [...accounts].sort((left, right) => {
    const labelOrder = getAccountDisplayName(left).toLocaleLowerCase().localeCompare(getAccountDisplayName(right).toLocaleLowerCase());
    if (labelOrder !== 0) return labelOrder;

    const domainOrder = (getAccountDomain(left) || "").toLocaleLowerCase().localeCompare((getAccountDomain(right) || "").toLocaleLowerCase());
    return domainOrder !== 0 ? domainOrder : left.account_id.toLocaleLowerCase().localeCompare(right.account_id.toLocaleLowerCase());
  });
}
